import React from "react";
import { LucideIcon } from "lucide-react";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  ctaLabel?: string;
  onCtaClick?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  ctaLabel,
  onCtaClick,
}) => (
  <div className="flex flex-col items-center text-center py-8 px-4 animate-fade-in-up">
    <div className="w-12 h-12 rounded-2xl bg-warm-blue/10 flex items-center justify-center mb-3">
      <Icon size={22} className="text-warm-blue" />
    </div>
    <h3 className="text-sm font-bold text-warm-text-primary mb-1">{title}</h3>
    <p className="text-xs text-warm-text-tertiary mb-3">{description}</p>
    {ctaLabel && onCtaClick && (
      <button
        onClick={onCtaClick}
        className="text-xs font-bold text-warm-blue hover:text-warm-blue-dark transition-all hover:scale-105 active:scale-95 px-3 py-1.5 rounded-full bg-warm-blue/10 hover:bg-warm-blue/15"
      >
        {ctaLabel}
      </button>
    )}
  </div>
);

export default EmptyState;
